import http from "./HttpService";
import { loginWithJwt } from "./JwtService";
import {logger} from "./LogService";

export async function login(username, password) {
    const { data } = await http.post("/authenticate/", {
        username,
        password,
    });
    logger.debug("login method");
    loginWithJwt(data.jwt);
    logger.debug("loginWithJWT successfull");
    http.setJwt();
}

export async function sso(ticket) {
    const { data } = await http.post("/sso/", "ticket=" + ticket);
    loginWithJwt(data.jwt);
    http.setJwt();
}
